import { notification } from "antd";

export const successAlert = (message) => notification["success"]({ message });
export const warningAlert = (message) => notification["warning"]({ message });
export const errorAlert = () =>
  notification["error"]({ message: "Oops! Something went wrong" });
